export default __webpack_public_path__ + "static/media/p17.2aaa8c05.jpg";